
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/details",
      function () {
        return require("private-next-pages/shops/details.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/details"])
      });
    }
  